import { each, forOwn } from 'lodash';
import type { ui } from 'angular';
import ngAnnotate from '../ngAnnotate.macro';

interface CancelRemainingAppointmentsScope extends ng.IScope {
  vm: {
    allAppointmentsSelected: boolean;
    selectedAppointmentsCount: number;
  };
  listing: todo;
  appointmentsLoaded: boolean;
  selectAppointments: boolean;
  selectedAppointments: Record<string, boolean>;
  appointments: todo[];
  appointmentSelected(): void;
  selectAllAppointments(): void;
  countSelectedAppointments(): void;
  close(): void;
  cancelRemainingAppointments(): void;
}

function CancelRemainingAppointments(
  $scope: CancelRemainingAppointmentsScope,
  $resource: ng.resource.IResourceService,
  pendingAppointments: todo[],
  listingId: string,
  $uibModalInstance: ui.bootstrap.IModalInstanceService,
) {
  const Listing = $resource('/listing/:id', { id: '@id' });
  $scope.vm = {
    allAppointmentsSelected: true,
    selectedAppointmentsCount: 0,
  };

  $scope.selectAllAppointments = () => {
    each($scope.appointments, d => {
      $scope.selectedAppointments[d.appointment.id] =
        $scope.vm.allAppointmentsSelected;
    });
    $scope.countSelectedAppointments();
  };

  $scope.countSelectedAppointments = () => {
    $scope.vm.selectedAppointmentsCount = 0;
    forOwn($scope.selectedAppointments, value => {
      if (value) $scope.vm.selectedAppointmentsCount += 1;
    });
  };

  $scope.appointmentSelected = () => {
    $scope.countSelectedAppointments();
  };

  $scope.appointments = pendingAppointments;
  $scope.selectedAppointments = {};

  $scope.selectAppointments = true;
  $scope.selectAllAppointments();

  Listing.get({ id: listingId }).$promise.then(listing => {
    $scope.listing = listing;
    $scope.appointmentsLoaded = true;
  });

  $scope.close = () => {
    $uibModalInstance.dismiss('close');
  };

  $scope.cancelRemainingAppointments = () => {
    $uibModalInstance.close($scope.selectedAppointments);
  };
}

ngAnnotate(CancelRemainingAppointments);

export default CancelRemainingAppointments;
